// extracted by mini-css-extract-plugin
export default {"textShieldRoot":"textShieldRoot___Wki2G","s":"s___lOkHm","m":"m___GzseY","l":"l___BnzK9","static":"static___MiUN7","textShieldImg":"textShieldImg___lIydx"};